import { Grid, FormControlLabel, Checkbox } from "@mui/material";
import StyledBadge from "../../../../components/styledBadge/StyledBadge";
import {
  ParticipantData,
  SearchCriteria,
} from "../interface/bookingOverviewInterface";
import React from "react";
import { BookingOverviewContext } from "../context/bookingOverviewContext";

const RenderFilterCheckboxes = (): React.JSX.Element => {
  const {
    searchCriteria,
    setSearchCriteria,
    participantData,
  }: {
    searchCriteria: SearchCriteria;
    setSearchCriteria: (searchCriteria: SearchCriteria) => void;
    participantData: ParticipantData[] | null;
  } = React.useContext(BookingOverviewContext);

  return (
    <Grid
      item
      sm={12}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: 2,
      }}
    >
      <StyledBadge
        sx={{ pr: 1, mr: 4 }}
        badgeContent={
          participantData?.filter(
            (participant: ParticipantData) => participant.status === 0
          ).length
        }
        color="secondary"
      >
        <FormControlLabel
          control={
            <Checkbox
              onClick={() => {
                setSearchCriteria({
                  ...searchCriteria,
                  status: {
                    ...searchCriteria.status,
                    active: !searchCriteria.status.active,
                  },
                });
              }}
              checked={searchCriteria.status.active}
            />
          }
          label="Zeige aktive"
        />
      </StyledBadge>

      <StyledBadge
        sx={{ pr: 1, mr: 4 }}
        badgeContent={
          participantData?.filter(
            (participant: ParticipantData) => participant.status === 1
          ).length
        }
        color="secondary"
      >
        <FormControlLabel
          control={
            <Checkbox
              onClick={() => {
                setSearchCriteria({
                  ...searchCriteria,
                  status: {
                    ...searchCriteria.status,
                    inactive: !searchCriteria.status.inactive,
                  },
                });
              }}
              checked={searchCriteria.status.inactive}
            />
          }
          label="Zeige inaktive"
        />
      </StyledBadge>
    </Grid>
  );
};

export default RenderFilterCheckboxes;
